<!-- <div class="mt-3">
    <div class="container-fluid"> -->
<!-- <form [formGroup]="form">
                <div class="row mt-3">

                    <div class="col-md-3" *ngIf="!hideCompany">
                        <label class="form-label required" for="company_id">Company</label>
                        <ng-select [items]="companyList" bindLabel="company_name" bindValue="id" [clearable]="false"
                            placeholder="Select Company" formControlName="company_id"
                            [ngClass]="{ 'is-invalid': isInvalid('company_id') }" (change)="onCompanyChange($event)">
                        </ng-select>
                        <div *ngIf="isInvalid('company_id')" class="invalid-feedback">
                            <span *ngIf="form.get('company_id')?.errors?.['required']">
                                Company is required.
                            </span>
                        </div>
                    </div>

                    <div class="col-md-3">
                        <label class="form-label required">Employee</label>
                        <ng-select formControlName="employee_id" placeholder="Select Employee" [clearable]="false"
                            [ngClass]="{ 'is-invalid': isInvalid('employee_id') }">

                            <ng-option *ngFor="let item of employeeList" [value]="item.id">
                                {{ item.firstname }} {{ item.lastname }} ({{ item?.Designation?.name }})
                            </ng-option>
                        </ng-select>

                        <div *ngIf="isInvalid('employee_id')" class="invalid-feedback">
                            <span *ngIf="form.get('employee_id')?.errors?.['required']">
                                Employee is required.
                            </span>
                        </div>
                    </div>

                    <div class="col-sm-3">
                        <label class="form-label required">From Date</label>
                        <div>
                            <p-calendar formControlName="from_date" [dateFormat]="date" [minDate]="minDate"
                                [maxDate]="maxDate" [iconDisplay]="'input'" touchUI="true" [showIcon]="true"
                                styleClass="custom-calendar" inputId="icondisplay"
                                (onSelect)="onDateChange($event ,'from_date')"
                                [ngClass]="{ 'is-invalid': isInvalid('from_date') }">
                            </p-calendar>
                            <div *ngIf="isInvalid('from_date')" class="invalid-feedback">
                                <span *ngIf="form.get('from_date')?.errors?.['required']"> From Date is required.
                                </span>
                            </div>
                        </div>
                    </div>

                    <div class="col-sm-3">
                        <label class="form-label required">To Date</label>
                        <div>
                            <p-calendar formControlName="to_date" [dateFormat]="date" [maxDate]="maxDate"
                                [iconDisplay]="'input'" touchUI="true" [showIcon]="true" styleClass="custom-calendar"
                                inputId="icondisplay" (onSelect)="onDateChange($event ,'to_date')"
                                [ngClass]="{ 'is-invalid': isInvalid('to_date') }" [minDate]="form.value.from_date"
                                [defaultDate]="form.value.from_date">
                            </p-calendar>
                            <div *ngIf="isInvalid('to_date')" class="invalid-feedback">
                                <span *ngIf="form.get('to_date')?.errors?.['required']"> To Date is required. </span>
                            </div>
                        </div>
                    </div>
                </div>


                <div class="row mt-3" *ngIf="this.form.value.sections.length > 0">
                    <div class="col-12">
                        <table class="table table-bordered table-reqularization px-3">
                            <thead>
                                <tr>
                                    <th class="tHead">Date</th>
                                    <th class="tHead">Status</th>
                                    <th class="tHead">Shift Time</th>
                                    <th class="tHead">Check-In Time</th>
                                    <th class="tHead">Check-Out Time</th>
                                    <th class="tHead">Comments</th>
                                </tr>
                            </thead>
                            <tbody formArrayName="sections">
                                <tr *ngFor="let section of form.get('sections')['controls']; let i = index"
                                    [formGroupName]="i">
                                    <td>{{ section.get('calendar_date')?.value | date: angularDateFormat }}</td>
                                    <td>{{ section.get('status')?.value ? section.get('status')?.value : '---' }}</td>
                                    <td>{{ section.get('shift_time')?.value ? section.get('shift_time')?.value : '---' }}</td>
                                    <td>
                                        <ng-container
                                            *ngIf="section.get('status')?.value === 'Leave Approved' || section.get('status')?.value === 'Leave Request Pending'">
                                            ---
                                        </ng-container>
                                        <ng-container
                                            *ngIf="section.get('status')?.value !== 'Leave Approved' && section.get('status')?.value !== 'Leave Request Pending'">
                                            <div class="custom-timepicker">
                                                <div class="input-group">
                                                    <input class="form-control"
                                                        [ngClass]="{ 'is-invalid': saveClick && section.get('checkin_time')?.errors }"
                                                        formControlName="checkin_time"
                                                        [ngxTimepicker]="startTimePicker" placeholder="Select time" readonly>
                                                    <div class="input-group-append">
                                                        <button class="btn btn-outline-secondary" type="button" (click)="startTimePicker.open()">
                                                            <i class="fa-regular fa-clock"></i>
                                                        </button>
                                                    </div>
                                                </div>
                                                <ngx-material-timepicker #startTimePicker [format]="24"></ngx-material-timepicker>

                                                <div *ngIf="
                                                    (section.get('checkin_time')?.errors) ||
                                                    (section.get('checkin_time')?.invalid &&
                                                    (section.get('checkin_time')?.dirty || section.get('checkin_time')?.touched))
                                                    " class="invalid-feedback">
                                                    <span class="d-flex" *ngIf="section.get('checkin_time')?.errors?.['required']">Enter
                                                        checkin_time</span>
                                                </div>
                                            </div>
                                        </ng-container>
                                    </td>
                                    <td>
                                        <ng-container
                                            *ngIf="section.get('status')?.value === 'Leave Approved' || section.get('status')?.value === 'Leave Request Pending'">
                                            ---
                                        </ng-container>
                                        <ng-container
                                            *ngIf="section.get('status')?.value !== 'Leave Approved' && section.get('status')?.value !== 'Leave Request Pending'">
                                            <div class="custom-timepicker">
                                                <div class="input-group">
                                                    <input class="form-control"
                                                        [ngClass]="{ 'is-invalid': saveClick && section.get('checkout_time')?.errors }"
                                                        formControlName="checkout_time"
                                                        [ngxTimepicker]="endTimePicker" placeholder="Select time" readonly>
                                                    <div class="input-group-append">
                                                        <button class="btn btn-outline-secondary" type="button" (click)="endTimePicker.open()">
                                                            <i class="fa-regular fa-clock"></i>
                                                        </button>
                                                    </div>
                                                </div>
                                                <ngx-material-timepicker #endTimePicker [format]="24"></ngx-material-timepicker>

                                                <div *ngIf="
                                                    (section.get('checkout_time')?.errors) ||
                                                    (section.get('checkout_time')?.invalid &&
                                                    (section.get('checkout_time')?.dirty || section.get('checkout_time')?.touched))
                                                    " class="invalid-feedback">
                                                    <span class="d-flex" *ngIf="section.get('checkout_time')?.errors?.['required']">Enter
                                                        checkout_time</span>
                                                </div>
                                            </div>
                                        </ng-container>
                                    </td>
                                    <td>
                                        <textarea id="comments" class="form-control" placeholder="Comments"
                                            formControlName="comments" [ngClass]="{
                                                    'is-invalid': section.get('comments')?.invalid &&
                                                                (section.get('comments')?.dirty || section.get('comments')?.touched || saveClick)
                                                }">
                                        </textarea>

                                        <div *ngIf="
                                            section.get('comments')?.invalid &&
                                            (section.get('comments')?.dirty || section.get('comments')?.touched || saveClick)"
                                            class="invalid-feedback">

                                            <span class="d-flex" *ngIf="section.get('comments')?.errors?.['required']">
                                                Enter comments
                                            </span>

                                            <span class="d-flex" *ngIf="section.get('comments')?.errors?.['maxlength']">
                                                Maximum length is 250 characters.
                                            </span>

                                            <span class="d-flex" *ngIf="section.get('comments')?.errors?.['pattern']">
                                                Only letters are allowed
                                            </span>
                                        </div>

                                    </td>
                                </tr>
                            </tbody>
                        </table>
                    </div>
                </div>


                <div class="row mt-3" *ngIf="this.form.value.from_date && this.form.value.to_date">
                    <div class="col-12 text-end">
                        <button type="button" class="btn btn-sm submit" (click)="formSubmit()">
                            Update
                        </button>
                    </div>
                </div>
            </form> -->

<!-- <div class="table-responsive">
            <table class="table table-bordered table-reqularization px-3">
                <thead>
                    <tr>
                        <th class="tHead">Date</th>
                        <th class="tHead">Actual Punch-In</th>
                        <th class="tHead">Actual Punch-Out</th>
                        <th class="tHead">Requested Punch-In</th>
                        <th class="tHead">Requested Punch-Out</th>
                        <th class="tHead">Comments</th>
                        <th class="tHead">Status</th>
                    </tr>
                </thead>
                <tbody>
                    <tr *ngFor="let section of requestedListData; let i = index">
                        <td>{{ section?.calendar_date | date: angularDateFormat }}</td>
                        <td>
                            {{ section?.attendance?.checkin_time ?
                            (section?.attendance?.checkin_time | date:'hh:mm a':'UTC') : '---'
                            }}
                        </td>
                        <td>
                            {{ section?.attendance?.checkout_time ?
                            (section?.attendance?.checkout_time | date:'hh:mm a':'UTC') : '---'
                            }}
                        </td>
                        <td>
                            {{ section?.missedpunches?.checkin_time ?
                            (section?.missedpunches?.checkin_time | date:'hh:mm a':'UTC') : '---'
                            }}
                        </td>
                        <td>
                            {{ section?.missedpunches?.checkout_time ?
                            (section?.missedpunches?.checkout_time | date:'hh:mm a':'UTC') : '---'
                            }}
                        </td>
                        <td>
                            {{section.comments ? section.comments : '---'}}
                        </td>
                        <td>
                            {{section.missedpunchrequest ? section.missedpunchrequest : '---'}}
                        </td>
                    </tr>
                </tbody>
            </table>
            <div *ngIf="requestedListData?.length == 0" class="no_data">
                No data to display
            </div>
        </div> -->

<!-- <div *ngIf="!regularaizationPage">
            <div class="mt-3">
                <div class="table-responsive">
                    <table class="table table-bordered table-reqularization px-3">
                        <thead>
                            <tr>
                                <th class="tHead vertical-align-middle">Employee Name</th>
                                <th class="tHead vertical-align-middle">Date</th>
                                <th class="tHead vertical-align-middle">Actual Punch-In</th>
                                <th class="tHead vertical-align-middle">Actual Punch-Out</th>
                                <th class="tHead vertical-align-middle">Requested Punch-In</th>
                                <th class="tHead vertical-align-middle">Requested Punch-Out</th>
                                <th class="tHead vertical-align-middle">Comments</th>
                                <th class="tHead vertical-align-middle">Action</th>
                            </tr>
                        </thead>
                        <tbody>
                            <tr *ngFor="let section of listData; let i = index">
                                <td>{{section?.employee?.firstname}} {{section?.employee?.lastname}}</td>
                                <td>{{ section.calendar_date | date: 'dd-MM-YYYY' }}</td>
                                <td>
                                    {{ section?.checkin_time ?
                                    (section?.checkin_time | date:'hh:mm a':'UTC') : '---'
                                    }}
                                </td>
                                <td>
                                    {{ section?.checkout_time ?
                                    (section?.checkout_time | date:'hh:mm a':'UTC') : '---'
                                    }}
                                </td>
                                <td>
                                    {{ section?.missedpunches?.checkin_time ?
                                    (section?.missedpunches?.checkin_time | date:'hh:mm a':'UTC') : '---'
                                    }}
                                </td>
                                <td>
                                    {{ section?.missedpunches?.checkout_time ?
                                    (section?.missedpunches?.checkout_time | date:'hh:mm a':'UTC') : '---'
                                    }}
                                </td>
                                <td>
                                    {{section.comments ? section.comments : '---'}}
                                </td>
                                <td *ngIf="isapprover">
                                    <button type="button" class="btn submit approve me-2"
                                        *ngIf="section.missedpunchrequest == 'Pending'" (click)="onApprove(section)">
                                        Approve
                                    </button>
                                    <span *ngIf="section.missedpunchrequest !== 'Pending'" class="status-badge">
                                        {{ section.missedpunchrequest }}
                                        <i *ngIf="section.missedpunchrequest === 'Approved'"
                                            class="fa fa-check status-icon approved"></i>
                                        <i *ngIf="section.missedpunchrequest === 'Rejected'"
                                            class="fa fa-times status-icon rejected"></i>
                                    </span>


                                    <button type="button" class="btn submit reject"
                                        *ngIf="section.missedpunchrequest == 'Pending'" (click)="onReject(section)">
                                        Reject
                                    </button>
                                </td>
                            </tr>
                        </tbody>
                    </table>
                </div>
                <div *ngIf="listData?.length == 0" class="no_data">
                    No data to display
                </div>
            </div>
        </div> -->
<!-- </div>
</div> -->

<div class="container-fluid">
    <div class="card-header row d-flex align-items-center">
        <div class="col-sm-3">
            <app-search #searchPlaceholder placeholder="Search" (keyup)="searchTable($event)"></app-search>
        </div>
        <div class="col-sm-9 d-flex justify-content-end align-items-center">
            <button class="btn submit" [routerLink]="['/app/attendance/apply-attendance-regularization/add']"
                *ngIf="checkPermission('save') && !approverPage">
                Add
            </button>
            <app-action-button (viewChange)="onViewChange($event)" [activeView]="viewType">
            </app-action-button>
            <app-table-export-import-button [tableId]="'menusTable'" class="import_btn" tablename="attendance-regularization"
                [listData]="leaveList" [reportName]="'attenRegTable'" [sectionid]="42"
                *ngIf="checkPermission('export')"
                [fetchAllData]="getAllForExport.bind(this)" [exportColumns]="myColumns">
            </app-table-export-import-button>
        </div>
    </div>
    <div class="card-body mt-2">
        <!-- <p-table id="menusTable" styleClass="p-datatable-gridlines" [value]="leaveList"
            [tableStyle]="{ 'min-width': '60rem' }">
            <ng-template pTemplate="header">
                <tr>
                    <th class="tHead text-center" style="width: 5%">S.No</th>
                    <th *ngIf="!hideCompany" class="tHead">
                        Company
                    </th>
                    <th class="tHead">
                        Employee
                    </th>
                    <th class="tHead">
                        Date
                    </th>
                    <th scope="" class="tHead">Created On</th>
                    <th scope="" class="tHead">Updated On</th>
                    <th scope="" class="tHead">Created By</th>
                    <th scope="" class="tHead">Updated By</th>
                    <th scope="" class="tHead text-center">Status</th>
                    <th style="text-align: center;" class="tHead" *ngIf="checkPermission('edit')">
                        Action
                    </th>
                </tr>
            </ng-template>
            <ng-template pTemplate="body" let-leaveList let-i="rowIndex">
                <tr>
                    <td class="text-center">{{ page == 0 ? i + 1 : i + 1 + pageSize * (page - 1) }}</td>
                    <td *ngIf="!hideCompany" class="">{{ leaveList?.company?.company_name }}</td>
                    <td>{{ leaveList?.employee?.firstname }} {{leaveList?.employee?.lastname || ''}}</td>
                    <td>{{ leaveList?.start_date | date: (angularDateFormat || dateFormat) }} - {{leaveList?.end_date |
                        date: (angularDateFormat || dateFormat)}}</td>
                    <td class="table-width-allowance">
                        {{ leaveList?.created_at | customDate: (angularDateFormat || dateFormat) + ' hh:mm a' }}
                    </td>
                    <td class="table-width-allowance">
                        {{ (leaveList?.updated_at && leaveList?.updated_by) ? (leaveList?.updated_at | customDate:
                        (angularDateFormat || dateFormat) + ' hh:mm a') : '---' }}
                    </td>
                    <td class="table-width-allowance">
                        {{ leaveList?.createdBy?.name || '---' }}
                    </td>
                    <td class="table-width-allowance">
                        {{ leaveList?.updatedBy?.name || '---' }}
                    </td>
                    <td class="text-center">
                        <button type="button"
                            class="btn btn-status {{ leaveList.status == 'Pending' ? 'pending' : leaveList.status== 'Rejected' ? 'inactive' : leaveList.status == 'Cancelled' ? 'cancelled': 'active' }}">
                            {{leaveList.status}}
                        </button>
                    </td>
                    <td style="text-align: center">
                        <i class="fa-solid fa-user-circle edit_icon mx-1"
                            (click)="viewApprovers(mediacontent, leaveList)"
                            *ngIf="checkPermission('view') && leaveList.status != 'Cancelled'"></i>
                        <i class="fa-regular fa-pen-to-square edit_icon" *ngIf="checkPermission('edit')"
                            (click)="navigateTo(leaveList._id)"></i>
                    </td>
                </tr>
            </ng-template>
        </p-table>
        <p class="text-center py-2" *ngIf="leaveList?.length == 0">No Records Found</p>
    </div>
    <div class="d-flex justify-content-center py-3">
        <ngb-pagination *ngIf="leaveList?.length != 0" class="pagination-master" [maxSize]="10"
            [collectionSize]="totalRecords" [(page)]="page" [pageSize]="pageSize" [rotate]="true" [ellipses]="false"
            [boundaryLinks]="true" (pageChange)="handlePageChange($event)">
        </ngb-pagination>
    </div> -->
        <div *ngIf="viewType === 'list'">
            <app-custom-table #customTable [listData]="leaveList" [selectedColumns]="myColumns" [menuId]="menuId"
                [tableName]="'attenRegTable'" [moduleKey]="'attenRegModule'" [totalRecords]="totalRecords"
                [maxSize]="pageSize" [collectionSize]="totalRecords" [page]="page" [pageSize]="pageSize"
                [sectionid]="42" (pageChanges)="handleFilterChange($event)" [approverPage]="approverPage"
                (viewApproversClick)="viewApprovers(mediacontent, $event)" [angularDateFormat]="angularDateFormat"
                [dateFormat]="dateFormat" (columnsChanged)="myColumns = $event"></app-custom-table>
            <ngb-pagination *ngIf="leaveList && leaveList.length != 0" class="pagination-master" [maxSize]="pageSize"
                [collectionSize]="totalRecords" [(page)]="page" [pageSize]="pageSize" [rotate]="true" [ellipses]="false"
                [boundaryLinks]="true" (pageChange)="handlePageChange($event)">
            </ngb-pagination>
        </div>
        <!-- GRID VIEW -->
        <div *ngIf="viewType === 'grid'">
            <app-custom-grid [listData]="leaveList" [canEdit]="checkPermission('edit')" [moduleKey]="'attenRegModule'"
                [angularDateFormat]="angularDateFormat" [dateFormat]="dateFormat" [approverPage]="approverPage"
        [totalRecords]="totalRecords">
            </app-custom-grid>
            <ngb-pagination *ngIf="leaveList && leaveList.length != 0" class="pagination-master" [maxSize]="pageSize"
                [collectionSize]="totalRecords" [(page)]="page" [pageSize]="pageSize" [rotate]="true" [ellipses]="false"
                [boundaryLinks]="true" (pageChange)="handlePageChange($event)">
            </ngb-pagination>
        </div>
    </div>

    <!-- Popup -->
    <ng-template #mediacontent let-modal>
        <app-view-approval-workflow [approverList]="approverList"></app-view-approval-workflow>
        <!-- <div class="modal-header">
        <h5 class="modal-title" id="modal-basic-title">
            View Approval Workflo
        </h5>
        <i class="fas fa-times close-icon" (click)="clearForm()"></i>
    </div>
    <div class="modal-body master">
        <div class="form-group">
            <div class="approval-list">
                <div *ngFor="let item of approverList; let i = index" class="position-relative">

                    <div class="approver-box p-2 rounded shadow-sm mb-2 bg-light border-start border-4">
                        <div class="d-flex justify-content-between align-items-center">
                            <div class="d-flex align-items-center">
                                <img [src]="item.photo || 'assets/img/user-image.png'" alt="photo"
                                    class="photo-img rounded-circle me-3 border" width="48" height="48" />
                                <div>
                                    <div class="fw-bold fs-6">Approver {{ i + 1 }}: {{ item.fullName }}</div>
                                    <div class="text-muted small">Emp Code: {{ item?.Employee?.employeecode }}</div>
                                    <div class="mt-2">
                                        <span class="badge px-3 py-1" [ngClass]="{
                                    'bg-success': item.approver_status === 'Approved',
                                    'bg-danger': item.approver_status === 'Rejected',
                                    'bg-secondary': !item.approver_status
                                  }">
                                            {{ item.approver_status || 'Pending' }}
                                        </span>
                                    </div>
                                    <div class="row">
                                        <div class="col-md-12">
                                            <span class="small">Requested : {{ item.requested_date ?
                                                (item.requested_date | date:
                                                (angularDateFormat ||
                                                dateFormat)+ ' hh:mm a') : '---'}}
                                            </span>
                                        </div>
                                        <div class="col-md-12">
                                            <span class="small"> Approved: {{item?.approver_date ? (item?.approver_date | date:
                                                (angularDateFormat || dateFormat)+ '
                                                hh:mm a') : '---'}}
                                            </span>
                                        </div>
                                    </div>
                                </div>
                            </div>

                            <div class="text-end ms-4 small text-secondary" style="min-width: 140px;">
                                <div class="mb-1 d-flex align-items-center justify-content-end">
                                    <span class="font_weight">{{ item?.Employee?.CompanyModel?.company_name || ''
                                        }}</span>
                                </div>
                                <div class="d-flex align-items-center justify-content-end">
                                    <span class="font_size">{{ item?.Employee?.Designation?.name || '' }}</span>
                                </div>
                            </div>
                        </div>
                    </div>

                    <div *ngIf="i !== approverList.length - 1" class="text-center mb-1">
                        <i class="fa-solid fa-arrow-down-long arrow-primary fs-4"></i>
                    </div>
                </div>
            </div>
        </div>
    </div> -->
    </ng-template>